import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';

const ErrorPage = lazy(() => import('../../components/pages/errorPage'));

export const errorRoutes = {
	path: '/error',
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<Suspense fallback={<PageLoader />}>
					<ErrorPage />
				</Suspense>
			),
		},
	],
};
